interface SEOHeadProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType?: string;
  ogImage?: string;
  publishedTime?: string;
  modifiedTime?: string;
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType = 'website',
  ogImage = 'https://readdy.ai/api/search-image?query=dark%20dramatic%20entertainment%20gossip%20news%20community%20brand%20visual%20with%20mysterious%20and%20engaging%20atmosphere%20cinematic%20editorial%20style&width=1200&height=630&seq=og-default&orientation=landscape',
  publishedTime,
  modifiedTime,
}: SEOHeadProps) {
  const fullTitle = `${title} - 黑料社区`;
  const canonical = `https://heiliaoshequ.com${canonicalUrl}`;

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="黑料社区" />
      <meta property="og:locale" content="zh_CN" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      {publishedTime && <meta property="article:published_time" content={publishedTime} />}
      {modifiedTime && <meta property="article:modified_time" content={modifiedTime} />}
      <meta name="geo.region" content="CN" />
      <meta name="geo.placename" content="China" />
    </>
  );
}